import { Anchor, AnchorProps } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { termsCss } from "./TermsAndPrivacyPolicy.style";

const AnchorWithTrackEvent = withTrackEvent<AnchorProps>(Anchor);

const TermsAndPrivacyPolicy = () => {
  return (
    <p css={termsCss}>
      By signing into Newsela you agree to our{" "}
      <AnchorWithTrackEvent
        openInNewTab
        childrenWrapperElement="span"
        href="https://newsela.com/legal/terms"
        objectType={objectTypes.user}
        actionName={actionNames.navigate}
        streamProperties={{
          description: "Navigate to Terms page.",
        }}
        dataProps={{
          "data-qa-selector": "terms_anchor",
          "data-testid": "terms-anchor",
        }}
      >
        Terms
      </AnchorWithTrackEvent>{" "}
      and{" "}
      <AnchorWithTrackEvent
        openInNewTab
        childrenWrapperElement="span"
        href="https://newsela.com/legal/newsela-privacy-policy"
        objectType={objectTypes.user}
        actionName={actionNames.navigate}
        streamProperties={{
          description: "Navigate to Privacy Policy page.",
        }}
        dataProps={{
          "data-qa-selector": "privacy_policy_anchor",
          "data-testid": "privacy-policy-anchor",
        }}
      >
        Privacy&nbsp;Policy
      </AnchorWithTrackEvent>
      .
    </p>
  );
};

export default TermsAndPrivacyPolicy;
